import { useQuery } from "@tanstack/react-query";


export function GetTablaGastos() {
   const url = process.env.REACT_APP_URL_DIR + "tablagastos";
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["tablagastos"],
      queryFn: () =>
         fetch(url, {
            headers: {
               Authorization: `Bearer ${token}`, //mind the space before your token
            },
         }).then((res) => res.json())
   });
   return data;
}
